/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import http from 'hub-http/clients/apiClient';
import getEarlyRequesterResult from './getEarlyRequesterResult';
import { CONTACTS } from '../constants/EarlyRequesterNames';
const ENDPOINT = 'contacts/search/v1/search/contacts';
export function getContacts(isDevPortal = false) {
  // Dev portals will always return 403, instead return 0 and avoid sentry logging
  const isExpectedError = () => {
    if (isDevPortal) {
      return {
        total: 0
      };
    }
    return false;
  };
  const earlyRequest = getEarlyRequesterResult(CONTACTS, isExpectedError);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.post(ENDPOINT, {
    query: {
      clienttimeout: 7000
    },
    data: {
      filterGroups: [],
      count: 0,
      sorts: []
    }
  })) : null;
  return earlyRequestWithRetry ? earlyRequestWithRetry.then(contactsObject => {
    return contactsObject.total;
  }) : http.post(ENDPOINT, {
    query: {
      clienttimeout: 7000
    },
    data: {
      filterGroups: [],
      count: 0,
      sorts: []
    }
  }).then(contactsObject => {
    return contactsObject.total;
  });
}